import { HttpParams, HttpResponse } from '@angular/common/http';
import { AdminPanelUserDetails } from '../models/admin-panel-user-details';
import { TableRequestData } from '../models/table/table-request-param';

export class HttpUtils {
  public static toHttpParams(obj: Record<string, any>): HttpParams {
    let params = new HttpParams();

    Object.keys(obj).forEach((key) => {
      const value = obj[key];

      if (value === null || value === undefined) {
        return;
      }

      if (
        key === 'filters' &&
        typeof value === 'object' &&
        !Array.isArray(value)
      ) {
        Object.keys(value).forEach((filterKey) => {
          const filterValue = value[filterKey];
          if (filterValue !== null && filterValue !== undefined) {
            params = params.set(filterKey, filterValue.toString());
          }
        });
      } else if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v !== null && v !== undefined) {
            params = params.append(key, v.toString());
          }
        });
      } else if (typeof value === 'object') {
        params = params.set(key, JSON.stringify(value));
      } else {
        params = params.set(key, value.toString());
      }
    });

    return params;
  }

  public static formatDateToLocalDateString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // LocalDate w formacie yyyy-MM-dd
  }

  public static parseContentDisposition(
    header: string,
    defaultName: string,
  ): string {
    if (!header) return defaultName;

    const filenameRegex = /filename\*?=(?:UTF-8''|")?([^;"\n]+)(?:")?/i;
    const match = header.match(filenameRegex);

    if (match && match[1]) {
      return decodeURIComponent(match[1]);
    }

    return defaultName;
  }

  public static downloadFile(
    resp: HttpResponse<Blob>,
    fileFormat?: string,
    fileNameOverride?: string,
  ) {
    const contentDisposition = resp.headers.get('content-disposition');
    const fileName =
      fileNameOverride ??
      HttpUtils.parseContentDisposition(
        contentDisposition!,
        `plik_${new Date()}.${fileFormat ? fileFormat : 'zip'}`,
      );

    const url = window.URL.createObjectURL(resp.body!);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  public static withAdminPanelUserIdentityParams(
    userDetails: AdminPanelUserDetails,
    params: TableRequestData = {
      pageIndex: 0,
      pageSize: 10,
    },
  ): TableRequestData & {
    contextUserFirstName: string;
    contextUserLastName: string;
    contextUserPesel: string;
  } {
    return {
      ...params,
      contextUserFirstName: userDetails.personalData.firstName,
      contextUserLastName: userDetails.personalData.lastName,
      contextUserPesel: userDetails.personalData.pesel,
    };
  }
}
